// ============== TRANSLATIONS ==============
// Extracted from App.js for better maintainability

export const TRANSLATIONS = {
  en: {
    welcome: "Welcome to Your Buy Site",
    buy_sell_trade: "Buy, Sell & Trade",
    across_islands: "Across the Islands",
    search_placeholder: "What are you looking for?",
    for_sale: "For Sale",
    for_rent: "For Rent",
    for_trade: "For Trade",
    giveaway: "Giveaway",
    services: "Services",
    open_for_trade: "Open for Trade",
    verified_business: "Verified Business",
    price_incl_ob: "incl. OB",
    price_excl_ob: "excl. OB",
    per_hour: "/hour",
    nearby: "Nearby",
    live_auctions: "Live Auctions",
    all_areas: "All Areas",
    home: "Home",
    marketplace: "Marketplace",
    my_listings: "My Listings",
    sign_in: "Sign In",
    sign_up: "Sign Up",
    get_started: "Get Started",
    create_listing: "Create Listing",
    create: "Create",
    profile: "Profile",
    sign_out: "Sign Out",
    translate: "Translate",
    hide: "Hide",
    translated_from: "Translated from",
    translation_failed: "Translation failed",
    search: "Search",
    grid_view: "Grid view",
    list_view: "List view",
    save_search: "Save this search",
    filters: "Filters",
    category: "Category",
    location: "Location",
    price: "Price",
    type: "Type",
    currency: "Currency",
    all_categories: "All Categories",
    all_locations: "All Locations",
    all_types: "All Types",
    min_price: "Min Price",
    max_price: "Max Price",
    clear_filters: "Clear Filters",
    sort_by: "Sort by",
    newest: "Newest",
    oldest: "Oldest",
    // List view card translations
    status_sold: "Sold",
    status_reserved: "Reserved",
    status_under_offer: "Under Offer",
    price_reduced: "Reduced",
    promoted_badge: "Boosted",
    listing_type_auction: "Auction",
    listing_type_rental: "Rental",
    listing_type_sale: "For Sale",
    listing_type_yard_sale: "Yard Sale",
    bid: "bid",
    bids: "bids",
    item: "item",
    items: "items",
    unknown_location: "Unknown",
    price_on_request_short: "Price TBD",
    ended: "Ended",
    // Personalized recommendations
    personalized_for_you: "Possibly interesting for you",
    based_on_search: "based on \"{query}\"",
    based_on_your_searches: "based on your searches",
    clear_history: "Clear history",
    see_all: "See all",
    price_low_high: "Price: Low to High",
    price_high_low: "Price: High to Low",
    popular: "Most Popular",
    no_listings: "No listings found",
    views: "views",
    contact_seller: "Contact Seller",
    send_message: "Send Message",
    propose_trade: "Propose Trade",
    private_seller: "Private Seller",
    business: "Business",
    // Auth
    email: "Email",
    password: "Password",
    name: "Full Name",
    phone: "Phone Number",
    account_type: "Account Type",
    private_account: "Private Account",
    business_account: "Business Account",
    business_name: "Business Name",
    kvk_number: "KVK Number (Chamber of Commerce)",
    preferred_language: "Preferred Language",
    preferred_currency: "Preferred Currency",
    register: "Register",
    login: "Login",
    already_have_account: "Already have an account?",
    dont_have_account: "Don't have an account?",
    // Listing form
    title: "Title",
    description: "Description",
    listing_type: "Listing Type",
    sell: "Sell",
    rent: "Rent",
    trade: "Trade",
    service: "Service",
    images: "Images",
    features: "Features",
    add_feature: "Add Feature",
    contact_info: "Contact Information",
    pricing: "Pricing",
    amount: "Amount",
    price_type: "Price Type",
    no_tax: "No Tax",
    incl_tax: "Including OB Tax",
    excl_tax: "Excluding OB Tax",
    ob_percentage: "OB Percentage",
    hourly_rate: "Hourly Rate",
    additional_costs: "Additional Costs",
    trade_options: "Trade Options",
    trade_value: "Trade Value",
    trade_preferences: "What would you trade for?",
    // Location
    address: "Address",
    city: "City",
    area: "Area",
    country: "Country",
    use_current_location: "Use Current Location",
    // Theme
    dark_mode: "Dark Mode",
    light_mode: "Light Mode",
    // Special listings
    yard_sale: "Yard Sale",
    porch_sale: "Porch Sale",
    auction: "Auction",
    bulk_sale: "Bulk Sale",
    special_listings: "Special Listings",
    discover_deals: "Discover Amazing Deals",
    host_yard_sale: "Host a Yard Sale",
    start_auction: "Start an Auction",
    safety_tips: "Safety Tips",
    meet_public: "Meet in a public place",
    check_item: "Check the item before paying",
    no_advance: "Don't pay in advance",
    report_suspicious: "Report suspicious activity",
    location_on_request: "Location on request from seller",
    view_location: "View Location",
    tap_to_view_map: "Tap to view map",
    support_us: "Support Us",
    donation_text: "Help us keep this platform free",
    // Property amenities
    pool: "Pool",
    sea_view: "Sea View",
    garden: "Garden",
    garage: "Garage",
    carport: "Carport",
    air_conditioning: "Air Conditioning",
    furnished: "Furnished",
    parking: "Parking",
    security: "Security",
    balcony: "Balcony",
    property_amenities: "Property Amenities",
    // Footer
    footer_tagline: "The trusted marketplace for the ABC islands.",
    footer_explore: "Explore",
    footer_resources: "Resources",
    footer_contact: "Contact",
    footer_events: "Events",
    footer_hotspots: "Hotspots",
    footer_about: "About Us",
    footer_install_app: "Install App",
    footer_boost_listing: "Boost Listing",
    footer_currency_converter: "Currency Converter",
    footer_faq: "FAQ",
    footer_feedback: "Feedback",
    footer_terms: "Terms",
    footer_privacy: "Privacy",
    // Footer forms
    advertise_with_us: "Advertise With Us",
    have_suggestions: "Have Suggestions?",
    your_message: "Your Message",
    company_name: "Company Name",
    submit: "Submit",
    sending: "Sending...",
    // Location search
    search_radius: "Search Radius",
    use_my_location: "Use My Location",
    within_km: "Within {km} km",
    // Account switching
    switch_account: "Switch Account",
    link_account: "Link Account",
    linked_accounts: "Linked Accounts",
    // Navigation & Actions
    logout: "Logout",
    favorites: "Favorites",
    messages: "Messages",
    notifications: "Notifications",
    settings: "Settings",
    // Auth extended
    confirm_password: "Confirm Password",
    full_name: "Full Name",
    create_account: "Create Account",
    creating_account: "Creating Account...",
    or_continue_with: "Or continue with",
    guest: "Guest",
    // StartSellingPage
    start_selling: "Start Selling",
    hero_title: "Turn Your Items Into Cash",
    hero_subtitle: "Join thousands of sellers on the ABC islands",
    benefit_1: "Reach Local Buyers",
    benefit_1_desc: "Connect with buyers across Aruba, Bonaire, and Curaçao",
    benefit_2: "Easy Listing",
    benefit_2_desc: "Create your listing in minutes with our simple form",
    benefit_3: "Secure Transactions",
    benefit_3_desc: "Safe messaging and verified profiles",
    // Analytics
    boost_click: "Boost Click",
    dismiss_click: "Dismiss Click", 
    popup_view: "Popup View",
    promotion: "Promotion",
    conversation: "Conversation",
    // Business CTA & Campaign
    cta_view_promo: "View Promotion",
    cta_view_event: "Discover Event",
    cta_view_sale: "View Sale",
    campaign_ends: "Ends on:",
    campaign_active: "Active until:",
    campaign_starts: "Starts:",
    campaign_running: "Running now",
    cta_url_label: "External Link (URL)",
    cta_url_placeholder: "https://yourshop.com/promo",
    cta_type_label: "Button Type",
    cta_type_promotion: "Promotion / Offer",
    cta_type_event: "Event / Weekend Sale",
    cta_type_sale: "Sale",
    campaign_period: "Campaign Period",
    campaign_start_label: "Start Date",
    campaign_end_label: "End Date",
    cta_business_only: "Available for verified business accounts only",
    cta_section_title: "Call-to-Action & Campaign",
    cta_section_desc: "Add an external link to drive traffic to your webshop or promotion page",
    // Common
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    share: "Share",
    report: "Report",
    contact: "Contact",
    categories: "Categories",
    buy: "Buy",
    // Profile Page
    active_sessions: "Active Sessions",
    add_banner_photo: "Add a banner photo",
    all_your_bids: "All your bids on auctions",
    all_your_events: "All your events and RSVPs",
    all_your_listings: "All your listings",
    all_your_messages: "All your messages and conversations",
    crypto: "Crypto",
    dark: "Dark",
    light: "Light",
    system: "System",
    delete_account: "Delete Account",
    invalidate_sessions: "Invalidate all active sessions",
    permanently_delete: "Permanently delete account and all data. Cannot be undone.",
    require_login: "Require you to log in again",
    sign_out_all: "Sign out from all devices if unauthorized access suspected",
    sign_you_out: "Sign you out from all devices",
    theme: "Theme",
    this_will_delete: "This will permanently delete:",
    this_will: "This will:",
    usdt_erc20: "USDT (ERC20)",
    verified: "Verified",
    whatsapp: "WhatsApp",
    your_profile_info: "Your profile and account information",
    member_since: "Member since",
    // Create Listing
    select_category: "Select category",
    select_subcategory: "Select subcategory",
    describe_item: "Describe your item in detail...",
    item_name: "Item name",
    qty: "Qty",
    buy_all_for: "Buy all for...",
    optional: "Optional",
    describe_trade: "Describe what you'd trade for...",
    leave_empty: "Leave empty for no minimum",
    step: "Step",
    next: "Next",
    back: "Back",
    publish: "Publish",
    upload_images: "Upload Images",
    drag_drop: "Drag & drop images or click to browse",
    max_images: "Maximum {count} images",
    required: "Required",
    // Auction
    auction: "Auction",
    auction_settings: "Auction Settings",
    starting_bid: "Starting Bid",
    reserve_price: "Reserve Price",
    bid_increment: "Bid Increment",
    end_time: "End Time",
    auto_extend: "Auto Extend",
    current_bid: "Current Bid",
    place_bid: "Place Bid",
    your_bid: "Your Bid",
    bid_placed: "Bid Placed",
    outbid: "Outbid",
    winning: "Winning",
    ended: "Ended",
    // Messaging
    messages: "Messages",
    new_message: "New Message",
    type_message: "Type a message...",
    send: "Send",
    online: "Online",
    offline: "Offline",
    last_seen: "Last seen",
    no_messages: "No messages yet",
    start_conversation: "Start a conversation",
    // Notifications
    notifications: "Notifications",
    mark_all_read: "Mark all as read",
    no_notifications: "No notifications",
    // Status
    available: "Available",
    sold: "Sold",
    reserved: "Reserved",
    pending: "Pending",
    active: "Active",
    inactive: "Inactive",
    // Errors
    error_occurred: "An error occurred",
    try_again: "Try again",
    loading: "Loading...",
    no_results: "No results found",
    // Confirmation
    are_you_sure: "Are you sure?",
    yes: "Yes",
    no: "No",
    confirm: "Confirm",
    // Time
    today: "Today",
    yesterday: "Yesterday",
    days_ago: "{count} days ago",
    hours_ago: "{count} hours ago",
    minutes_ago: "{count} minutes ago",
    just_now: "Just now",
    // Listing Maintenance
    listing_expiry_warning: "Your listing expires soon",
    listing_expired: "Listing expired",
    listing_archived: "Listing archived",
    listing_reactivated: "Listing reactivated",
    yes_still_available: "Yes, still available",
    reactivated: "Reactivated!",
    extending: "Extending...",
    days_remaining: "days remaining",
    times_extended: "times extended",
    expired: "Expired",
    archived: "Archived",
    // Pricing Page
    pricing_hero_title: "Free Listings,",
    pricing_hero_highlight: "Boost for Extra Visibility",
    pricing_hero_subtitle: "Post your listings for free. Want to sell faster? Boost your listing to appear at the top.",
    pricing_free_title: "Free Listings",
    pricing_free_subtitle: "No hidden costs, no subscriptions",
    pricing_free_features_1: "Unlimited listings",
    pricing_free_features_2: "10 photos per listing",
    pricing_free_features_3: "30 days active",
    pricing_free_features_4: "Auto-renewal",
    pricing_free_features_5: "Send messages",
    pricing_free_features_6: "Basic statistics",
    pricing_free_cta: "Post Free Listing",
    pricing_boost_title: "Boost Your Listing",
    pricing_boost_subtitle: "More visibility, sell faster",
    pricing_boost_feature_1: "Top of search results",
    pricing_boost_feature_2: "Eye-catching boost badge",
    pricing_boost_feature_3: "More views & responses",
    pricing_boost_cta: "Boost Now",
    pricing_boost_popular: "POPULAR",
    pricing_boost_payment_info: "Secure payment via",
    pricing_boost_instant: "Instant activation after payment",
    pricing_hours: "hours",
    pricing_days: "days",
    pricing_hour_boost: "hour boost",
    pricing_day_boost: "day boost",
    pricing_faq_title: "Frequently Asked Questions",
    pricing_faq_1_q: "Is listing really free?",
    pricing_faq_1_a: "Yes! You can post unlimited listings for free. You only pay a small fee if you want extra visibility through a Boost.",
    pricing_faq_2_q: "How long does my listing stay online?",
    pricing_faq_2_a: "Your listing stays active for 30 days. After that, you can easily extend it from your dashboard.",
    pricing_faq_3_q: "How does Boost work?",
    pricing_faq_3_a: "With a Boost, your listing appears at the top of search results and gets an eye-catching badge. This gives you more views and helps you sell faster.",
    pricing_faq_4_q: "How do I pay for a Boost?",
    pricing_faq_4_a: "We use Sentoo for secure payments. Your Boost is activated immediately after payment.",
    pricing_faq_5_q: "Can I boost multiple listings?",
    pricing_faq_5_a: "Yes, you can boost each listing separately. This way you decide which items get extra attention.",
    pricing_cta_title: "Ready to Sell?",
    pricing_cta_subtitle: "Post your first listing now. It's free and online within minutes!",
    pricing_cta_button: "Post Free Listing",
    // Boost package names & descriptions
    pricing_boost_24h_name: "24 Hour Boost",
    pricing_boost_24h_desc: "Put your listing at the top for 24 hours",
    pricing_boost_7d_name: "7 Day Boost",
    pricing_boost_7d_desc: "Put your listing at the top for 7 days",
    pricing_boost_30d_name: "1 Month Boost",
    pricing_boost_30d_desc: "Put your listing at the top for 30 days",
    // Homepage sections
    fresh_arrivals: "Fresh Arrivals",
    just_listed: "Just Listed",
    browse_categories: "Browse Categories",
    view_all: "View all",
    upcoming_events: "Upcoming Events",
    dont_miss_experiences: "Don't miss out on these experiences",
    browse_listings: "Browse Listings",
    create_and_list: "Create & List",
    create_a_listing: "Create a Listing",
    create_and_promote: "Create & Promote",
    browse: "Browse",
    create_event: "Create Event",
    browse_all_events: "Browse All Events",
    view_all_listings: "View All Listings",
    browse_promoted_deals: "Browse {count}+ promoted deals",
    // Search
    search_marketplace: "Search YourBuySite...",
    search_category: "Search {category}...",
    // Navigation
    create: "Create",
    subcategory: "Subcategory",
    all: "All",
    // Mobile nav
    home: "Home",
    search: "Search",
    inbox: "Inbox",
    profile: "Profile",
    // Homepage sections - additional
    trending_now: "Trending Now",
    featured_listings: "Featured Listings",
    want_listing_stand_out: "Want your listing to stand out?",
    promote_your_listing: "Promote Your Listing",
    host_an_event: "Host an Event",
    share_event_community: "Share your event with the island community",
    check_whats_happening: "Check out what's happening on the islands",
    explore_marketplace: "Explore the Marketplace",
    find_what_looking_for: "Find what you're looking for across all categories",
    popular: "Popular",
    services_nav: "Services",
    ready_to_start_selling: "Ready to Start Selling?",
    join_thousands_sellers: "Join thousands of island sellers. List for free and reach buyers across all islands.",
    start_selling_free: "Start Selling Free",
    advertise_with_us: "Advertise With Us",
    reach_buyers_abc: "Reach buyers across the ABC islands",
    register_business: "Register Business",
    // Featured section
    get_featured: "Get Featured!",
    why_feature_listing: "Why Feature Your Listing?",
    more_visibility: "5x more visibility",
    priority_search: "Priority in search results",
    homepage_spotlight: "Homepage spotlight",
    trusted_seller_badge: "Trusted seller badge",
    promote_listing_reach: "Promote your listing to reach more buyers. Featured listings get 5x more views!",
    find_deals_yard_sales: "Find deals at local yard sales",
  },
  nl: {
    welcome: "Welkom bij Your Buy Site",
    buy_sell_trade: "Kopen, Verkopen & Ruilen",
    across_islands: "Over de Eilanden",
    search_placeholder: "Waar ben je naar op zoek?",
    for_sale: "Te Koop",
    for_rent: "Te Huur",
    for_trade: "Te Ruilen",
    giveaway: "Weggeefactie",
    services: "Diensten",
    open_for_trade: "Open voor Ruil",
    verified_business: "Geverifieerd Bedrijf",
    price_incl_ob: "incl. OB",
    price_excl_ob: "excl. OB",
    per_hour: "/uur",
    nearby: "In de buurt",
    live_auctions: "Live Veilingen",
    all_areas: "Alle Gebieden",
    home: "Home",
    marketplace: "Marktplaats",
    my_listings: "Mijn Advertenties",
    sign_in: "Inloggen",
    sign_up: "Registreren",
    get_started: "Aan de slag",
    create_listing: "Advertentie Plaatsen",
    create: "Plaatsen",
    profile: "Profiel",
    sign_out: "Uitloggen",
    translate: "Vertalen",
    hide: "Verbergen",
    translated_from: "Vertaald uit",
    translation_failed: "Vertaling mislukt",
    search: "Zoeken",
    grid_view: "Rasterweergave",
    list_view: "Lijstweergave",
    save_search: "Bewaar deze zoekopdracht",
    filters: "Filters",
    category: "Categorie",
    location: "Locatie",
    price: "Prijs",
    type: "Type",
    currency: "Valuta",
    all_categories: "Alle Categorieën",
    all_locations: "Alle Locaties",
    all_types: "Alle Types",
    min_price: "Min Prijs",
    max_price: "Max Prijs",
    clear_filters: "Filters Wissen",
    sort_by: "Sorteer op",
    newest: "Nieuwste",
    oldest: "Oudste",
    // List view card translations
    status_sold: "Verkocht",
    status_reserved: "Gereserveerd",
    status_under_offer: "Onder Bod",
    price_reduced: "Verlaagd",
    promoted_badge: "Gepromoot",
    listing_type_auction: "Veiling",
    listing_type_rental: "Verhuur",
    listing_type_sale: "Te Koop",
    listing_type_yard_sale: "Garageverkoop",
    bid: "bod",
    bids: "biedingen",
    item: "artikel",
    items: "artikelen",
    unknown_location: "Onbekend",
    price_on_request_short: "Op aanvraag",
    ended: "Afgelopen",
    // Personalized recommendations
    personalized_for_you: "Mogelijk interessant voor jou",
    based_on_search: "gebaseerd op \"{query}\"",
    based_on_your_searches: "op basis van je zoekopdrachten",
    clear_history: "Wis geschiedenis",
    see_all: "Bekijk alles",
    price_low_high: "Prijs: Laag naar Hoog",
    price_high_low: "Prijs: Hoog naar Laag",
    popular: "Populairst",
    no_listings: "Geen advertenties gevonden",
    views: "weergaven",
    contact_seller: "Contact Verkoper",
    send_message: "Bericht Sturen",
    propose_trade: "Ruil Voorstellen",
    private_seller: "Particuliere Verkoper",
    business: "Bedrijf",
    email: "E-mail",
    password: "Wachtwoord",
    name: "Volledige Naam",
    phone: "Telefoonnummer",
    account_type: "Accounttype",
    private_account: "Particulier Account",
    business_account: "Zakelijk Account",
    business_name: "Bedrijfsnaam",
    kvk_number: "KVK Nummer",
    preferred_language: "Voorkeurstaal",
    preferred_currency: "Voorkeursvaluta",
    register: "Registreren",
    login: "Inloggen",
    already_have_account: "Heb je al een account?",
    dont_have_account: "Nog geen account?",
    title: "Titel",
    description: "Beschrijving",
    listing_type: "Advertentietype",
    sell: "Verkopen",
    rent: "Verhuren",
    trade: "Ruilen",
    service: "Dienst",
    images: "Afbeeldingen",
    features: "Kenmerken",
    add_feature: "Kenmerk Toevoegen",
    contact_info: "Contactgegevens",
    pricing: "Prijzen",
    amount: "Bedrag",
    price_type: "Prijstype",
    no_tax: "Geen Belasting",
    incl_tax: "Inclusief OB",
    excl_tax: "Exclusief OB",
    ob_percentage: "OB Percentage",
    hourly_rate: "Uurtarief",
    additional_costs: "Extra Kosten",
    trade_options: "Ruilopties",
    trade_value: "Ruilwaarde",
    trade_preferences: "Waarvoor zou je willen ruilen?",
    address: "Adres",
    city: "Stad",
    area: "Gebied",
    country: "Land",
    use_current_location: "Gebruik Huidige Locatie",
    dark_mode: "Donkere Modus",
    light_mode: "Lichte Modus",
    yard_sale: "Garageverkoop",
    porch_sale: "Veranda Verkoop",
    auction: "Veiling",
    bulk_sale: "Grootverkoop",
    special_listings: "Speciale Aanbiedingen",
    discover_deals: "Ontdek Geweldige Deals",
    host_yard_sale: "Organiseer een Garageverkoop",
    start_auction: "Start een Veiling",
    safety_tips: "Veiligheidstips",
    meet_public: "Ontmoet op een openbare plaats",
    check_item: "Controleer het artikel voor betaling",
    no_advance: "Betaal niet vooraf",
    report_suspicious: "Meld verdachte activiteit",
    location_on_request: "Locatie op aanvraag bij verkoper",
    view_location: "Bekijk Locatie",
    tap_to_view_map: "Tik om kaart te bekijken",
    support_us: "Steun Ons",
    donation_text: "Help ons dit platform gratis te houden",
    pool: "Zwembad",
    sea_view: "Zeezicht",
    garden: "Tuin",
    garage: "Garage",
    carport: "Carport",
    air_conditioning: "Airconditioning",
    furnished: "Gemeubileerd",
    parking: "Parkeren",
    security: "Beveiliging",
    balcony: "Balkon",
    property_amenities: "Voorzieningen",
    // Footer
    footer_tagline: "De betrouwbare marktplaats voor de ABC eilanden.",
    footer_explore: "Verkennen",
    footer_resources: "Bronnen",
    footer_contact: "Contact",
    footer_events: "Evenementen",
    footer_hotspots: "Hotspots",
    footer_about: "Over Ons",
    footer_install_app: "Installeer App",
    footer_boost_listing: "Boost Advertentie",
    footer_currency_converter: "Valuta Omrekenen",
    footer_faq: "Veelgestelde Vragen",
    footer_feedback: "Feedback",
    footer_terms: "Voorwaarden",
    footer_privacy: "Privacy",
    // Footer forms
    advertise_with_us: "Adverteer Bij Ons",
    have_suggestions: "Suggesties?",
    your_message: "Uw Bericht",
    company_name: "Bedrijfsnaam",
    submit: "Versturen",
    sending: "Verzenden...",
    search_radius: "Zoekradius",
    use_my_location: "Gebruik Mijn Locatie",
    within_km: "Binnen {km} km",
    switch_account: "Wissel Account",
    link_account: "Account Koppelen",
    linked_accounts: "Gekoppelde Accounts",
    // Navigation & Actions
    logout: "Uitloggen",
    favorites: "Favorieten",
    messages: "Berichten",
    notifications: "Meldingen",
    settings: "Instellingen",
    // Auth extended
    confirm_password: "Bevestig Wachtwoord",
    full_name: "Volledige Naam",
    create_account: "Account Aanmaken",
    creating_account: "Account Aanmaken...",
    or_continue_with: "Of ga verder met",
    guest: "Gast",
    // StartSellingPage
    start_selling: "Begin met Verkopen",
    hero_title: "Maak Geld van je Spullen",
    hero_subtitle: "Sluit je aan bij duizenden verkopers op de ABC eilanden",
    benefit_1: "Bereik Lokale Kopers",
    benefit_1_desc: "Verbind met kopers op Aruba, Bonaire en Curaçao",
    benefit_2: "Makkelijk Plaatsen",
    benefit_2_desc: "Maak je advertentie in minuten met ons simpele formulier",
    benefit_3: "Veilige Transacties",
    benefit_3_desc: "Veilig berichten en geverifieerde profielen",
    // Analytics
    boost_click: "Boost Klik",
    dismiss_click: "Sluiten Klik",
    popup_view: "Popup Weergave",
    promotion: "Promotie",
    conversation: "Gesprek",
    // Business CTA & Campaign
    cta_view_promo: "Bekijk Actie",
    cta_view_event: "Ontdek Evenement",
    cta_view_sale: "Bekijk Sale",
    campaign_ends: "Loopt af op:",
    campaign_active: "Geldig tot:",
    campaign_starts: "Start:",
    campaign_running: "Nu actief",
    cta_url_label: "Externe Link (URL)",
    cta_url_placeholder: "https://jouwshop.nl/actie",
    cta_type_label: "Knop Type",
    cta_type_promotion: "Actie / Aanbieding",
    cta_type_event: "Evenement / Weekend Sale",
    cta_type_sale: "Sale",
    campaign_period: "Actieperiode",
    campaign_start_label: "Startdatum",
    campaign_end_label: "Einddatum",
    cta_business_only: "Alleen beschikbaar voor geverifieerde zakelijke accounts",
    cta_section_title: "Call-to-Action & Campagne",
    cta_section_desc: "Voeg een externe link toe om verkeer naar je webshop of actiepagina te leiden",
    // Common
    save: "Opslaan",
    cancel: "Annuleren",
    delete: "Verwijderen",
    edit: "Bewerken",
    share: "Delen",
    report: "Melden",
    contact: "Contact",
    categories: "Categorieën",
    buy: "Kopen",
    // Profile Page
    active_sessions: "Actieve Sessies",
    add_banner_photo: "Voeg een bannerfoto toe",
    all_your_bids: "Al je biedingen op veilingen",
    all_your_events: "Al je evenementen en RSVP's",
    all_your_listings: "Al je advertenties",
    all_your_messages: "Al je berichten en gesprekken",
    crypto: "Crypto",
    dark: "Donker",
    light: "Licht",
    system: "Systeem",
    delete_account: "Account Verwijderen",
    invalidate_sessions: "Alle actieve sessies ongeldig maken",
    permanently_delete: "Account en alle gegevens permanent verwijderen. Kan niet ongedaan worden.",
    require_login: "Vereist opnieuw inloggen",
    sign_out_all: "Uitloggen van alle apparaten bij verdachte toegang",
    sign_you_out: "Log je uit van alle apparaten",
    theme: "Thema",
    this_will_delete: "Dit verwijdert permanent:",
    this_will: "Dit zal:",
    usdt_erc20: "USDT (ERC20)",
    verified: "Geverifieerd",
    whatsapp: "WhatsApp",
    your_profile_info: "Je profiel en accountinformatie",
    member_since: "Lid sinds",
    // Create Listing
    select_category: "Selecteer categorie",
    select_subcategory: "Selecteer subcategorie",
    describe_item: "Beschrijf je artikel in detail...",
    item_name: "Naam artikel",
    qty: "Aantal",
    buy_all_for: "Alles kopen voor...",
    optional: "Optioneel",
    describe_trade: "Beschrijf waarvoor je zou willen ruilen...",
    leave_empty: "Laat leeg voor geen minimum",
    step: "Stap",
    next: "Volgende",
    back: "Terug",
    publish: "Publiceren",
    upload_images: "Afbeeldingen Uploaden",
    drag_drop: "Sleep afbeeldingen of klik om te bladeren",
    max_images: "Maximaal {count} afbeeldingen",
    required: "Verplicht",
    // Auction
    auction_settings: "Veiling Instellingen",
    starting_bid: "Startbod",
    reserve_price: "Minimumprijs",
    bid_increment: "Bod Verhoging",
    end_time: "Eindtijd",
    auto_extend: "Automatisch Verlengen",
    current_bid: "Huidig Bod",
    place_bid: "Bod Plaatsen",
    your_bid: "Jouw Bod",
    bid_placed: "Bod Geplaatst",
    outbid: "Overboden",
    winning: "Winnend",
    ended: "Geëindigd",
    // Messaging
    new_message: "Nieuw Bericht",
    type_message: "Typ een bericht...",
    send: "Verzenden",
    online: "Online",
    offline: "Offline",
    last_seen: "Laatst gezien",
    no_messages: "Nog geen berichten",
    start_conversation: "Start een gesprek",
    // Status
    available: "Beschikbaar",
    sold: "Verkocht",
    reserved: "Gereserveerd",
    pending: "In Behandeling",
    active: "Actief",
    inactive: "Inactief",
    // Errors
    error_occurred: "Er is een fout opgetreden",
    try_again: "Probeer opnieuw",
    loading: "Laden...",
    no_results: "Geen resultaten gevonden",
    // Confirmation
    are_you_sure: "Weet je het zeker?",
    yes: "Ja",
    no: "Nee",
    confirm: "Bevestigen",
    // Time
    today: "Vandaag",
    yesterday: "Gisteren",
    days_ago: "{count} dagen geleden",
    hours_ago: "{count} uur geleden",
    minutes_ago: "{count} minuten geleden",
    just_now: "Zojuist",
    // Listing Maintenance
    listing_expiry_warning: "Je advertentie verloopt binnenkort",
    listing_expired: "Advertentie verlopen",
    listing_archived: "Advertentie gearchiveerd",
    listing_reactivated: "Advertentie geheractiveerd",
    yes_still_available: "Ja, nog beschikbaar",
    reactivated: "Geheractiveerd!",
    extending: "Verlengen...",
    days_remaining: "dagen resterend",
    times_extended: "keer verlengd",
    expired: "Verlopen",
    archived: "Gearchiveerd",
    // Pricing Page
    pricing_hero_title: "Gratis Adverteren,",
    pricing_hero_highlight: "Boost voor Extra Zichtbaarheid",
    pricing_hero_subtitle: "Plaats gratis je advertenties. Wil je sneller verkopen? Boost je advertentie en kom bovenaan te staan.",
    pricing_free_title: "Gratis Adverteren",
    pricing_free_subtitle: "Geen verborgen kosten, geen abonnementen",
    pricing_free_features_1: "Onbeperkt advertenties",
    pricing_free_features_2: "10 foto's per advertentie",
    pricing_free_features_3: "30 dagen actief",
    pricing_free_features_4: "Automatisch verlengen",
    pricing_free_features_5: "Berichten versturen",
    pricing_free_features_6: "Basis statistieken",
    pricing_free_cta: "Plaats Gratis Advertentie",
    pricing_boost_title: "Boost Je Advertentie",
    pricing_boost_subtitle: "Meer zichtbaarheid, sneller verkopen",
    pricing_boost_feature_1: "Bovenaan in zoekresultaten",
    pricing_boost_feature_2: "Opvallende boost badge",
    pricing_boost_feature_3: "Meer views & reacties",
    pricing_boost_cta: "Boost Nu",
    pricing_boost_popular: "POPULAIR",
    pricing_boost_payment_info: "Veilig betalen via",
    pricing_boost_instant: "Directe activatie na betaling",
    pricing_hours: "uur",
    pricing_days: "dagen",
    pricing_hour_boost: "uur boost",
    pricing_day_boost: "dagen boost",
    pricing_faq_title: "Veelgestelde Vragen",
    pricing_faq_1_q: "Is adverteren echt gratis?",
    pricing_faq_1_a: "Ja! Je kunt onbeperkt advertenties plaatsen zonder kosten. Alleen als je extra zichtbaarheid wilt via een Boost, betaal je een klein bedrag.",
    pricing_faq_2_q: "Hoe lang blijft mijn advertentie online?",
    pricing_faq_2_a: "Je advertentie blijft 30 dagen actief. Daarna kun je hem eenvoudig verlengen vanuit je dashboard.",
    pricing_faq_3_q: "Hoe werkt de Boost?",
    pricing_faq_3_a: "Met een Boost komt je advertentie bovenaan de zoekresultaten te staan en krijgt een opvallende badge. Zo krijg je meer views en verkoop je sneller.",
    pricing_faq_4_q: "Hoe betaal ik voor een Boost?",
    pricing_faq_4_a: "We gebruiken Sentoo voor veilige betalingen. Na betaling wordt je Boost direct geactiveerd.",
    pricing_faq_5_q: "Kan ik meerdere advertenties boosten?",
    pricing_faq_5_a: "Ja, je kunt elke advertentie apart boosten. Zo bepaal je zelf welke items extra aandacht krijgen.",
    pricing_cta_title: "Klaar om te Verkopen?",
    pricing_cta_subtitle: "Plaats nu je eerste advertentie. Het is gratis en binnen enkele minuten online!",
    pricing_cta_button: "Gratis Advertentie Plaatsen",
    // Boost package names & descriptions
    pricing_boost_24h_name: "24 Uur Boost",
    pricing_boost_24h_desc: "Zet je advertentie 24 uur bovenaan",
    pricing_boost_7d_name: "7 Dagen Boost",
    pricing_boost_7d_desc: "Zet je advertentie 7 dagen bovenaan",
    pricing_boost_30d_name: "1 Maand Boost",
    pricing_boost_30d_desc: "Zet je advertentie 30 dagen bovenaan",
    // Homepage sections
    fresh_arrivals: "Nieuw Binnen",
    just_listed: "Net Geplaatst",
    browse_categories: "Bekijk Categorieën",
    view_all: "Bekijk alles",
    upcoming_events: "Aankomende Evenementen",
    dont_miss_experiences: "Mis deze ervaringen niet",
    browse_listings: "Bekijk Advertenties",
    create_and_list: "Maak & Plaats",
    create_a_listing: "Plaats Advertentie",
    create_and_promote: "Maak & Promoot",
    browse: "Bekijk",
    create_event: "Maak Evenement",
    browse_all_events: "Bekijk Alle Evenementen",
    view_all_listings: "Bekijk Alle Advertenties",
    browse_promoted_deals: "Bekijk {count}+ gepromote deals",
    // Search
    search_marketplace: "Zoek op YourBuySite...",
    search_category: "Zoek in {category}...",
    // Navigation
    create: "Plaatsen",
    subcategory: "Subcategorie",
    all: "Alles",
    // Mobile nav
    home: "Home",
    search: "Zoeken",
    inbox: "Berichten",
    profile: "Profiel",
    // Homepage sections - additional
    trending_now: "Trending Nu",
    featured_listings: "Uitgelichte Advertenties",
    want_listing_stand_out: "Wil je dat je advertentie opvalt?",
    promote_your_listing: "Promoot Je Advertentie",
    host_an_event: "Organiseer een Evenement",
    share_event_community: "Deel je evenement met de eilandgemeenschap",
    check_whats_happening: "Bekijk wat er gebeurt op de eilanden",
    explore_marketplace: "Verken de Marktplaats",
    find_what_looking_for: "Vind wat je zoekt in alle categorieën",
    popular: "Populair",
    services_nav: "Diensten",
    ready_to_start_selling: "Klaar om te Verkopen?",
    join_thousands_sellers: "Sluit je aan bij duizenden eilandverkopers. Plaats gratis en bereik kopers op alle eilanden.",
    start_selling_free: "Begin Gratis met Verkopen",
    advertise_with_us: "Adverteer Bij Ons",
    reach_buyers_abc: "Bereik kopers op de ABC-eilanden",
    register_business: "Registreer Bedrijf",
    // Featured section
    get_featured: "Word Uitgelicht!",
    why_feature_listing: "Waarom Je Advertentie Uitlichten?",
    more_visibility: "5x meer zichtbaarheid",
    priority_search: "Prioriteit in zoekresultaten",
    homepage_spotlight: "Homepage spotlight",
    trusted_seller_badge: "Betrouwbare verkoper badge",
    promote_listing_reach: "Promoot je advertentie om meer kopers te bereiken. Uitgelichte advertenties krijgen 5x meer views!",
    find_deals_yard_sales: "Vind deals bij lokale garageverkopen",
  },
  es: {
    welcome: "Bienvenido a Your Buy Site",
    buy_sell_trade: "Compra, Vende e Intercambia",
    across_islands: "En las Islas",
    search_placeholder: "¿Qué estás buscando?",
    for_sale: "En Venta",
    for_rent: "En Alquiler",
    for_trade: "Para Intercambio",
    giveaway: "Sorteo",
    services: "Servicios",
    open_for_trade: "Abierto a Intercambio",
    verified_business: "Negocio Verificado",
    price_incl_ob: "incl. OB",
    price_excl_ob: "excl. OB",
    per_hour: "/hora",
    nearby: "Cercano",
    live_auctions: "Subastas en Vivo",
    all_areas: "Todas las Áreas",
    home: "Inicio",
    marketplace: "Mercado",
    my_listings: "Mis Anuncios",
    sign_in: "Iniciar Sesión",
    sign_up: "Registrarse",
    get_started: "Comenzar",
    create_listing: "Crear Anuncio",
    create: "Crear",
    profile: "Perfil",
    sign_out: "Cerrar Sesión",
    translate: "Traducir",
    hide: "Ocultar",
    translated_from: "Traducido de",
    translation_failed: "Error de traducción",
    search: "Buscar",
    grid_view: "Vista de cuadrícula",
    list_view: "Vista de lista",
    save_search: "Guardar esta búsqueda",
    filters: "Filtros",
    category: "Categoría",
    location: "Ubicación",
    price: "Precio",
    type: "Tipo",
    currency: "Moneda",
    all_categories: "Todas las Categorías",
    all_locations: "Todas las Ubicaciones",
    all_types: "Todos los Tipos",
    min_price: "Precio Mín",
    max_price: "Precio Máx",
    clear_filters: "Limpiar Filtros",
    sort_by: "Ordenar por",
    newest: "Más Reciente",
    oldest: "Más Antiguo",
    // List view card translations
    status_sold: "Vendido",
    status_reserved: "Reservado",
    status_under_offer: "En Oferta",
    price_reduced: "Rebajado",
    promoted_badge: "Promocionado",
    listing_type_auction: "Subasta",
    listing_type_rental: "Alquiler",
    listing_type_sale: "En Venta",
    listing_type_yard_sale: "Venta de Garaje",
    bid: "oferta",
    bids: "ofertas",
    item: "artículo",
    items: "artículos",
    unknown_location: "Desconocido",
    price_on_request_short: "A consultar",
    ended: "Finalizado",
    // Personalized recommendations
    personalized_for_you: "Posiblemente interesante para ti",
    based_on_search: "basado en \"{query}\"",
    based_on_your_searches: "basado en tus búsquedas",
    clear_history: "Borrar historial",
    see_all: "Ver todo",
    price_low_high: "Precio: Menor a Mayor",
    price_high_low: "Precio: Mayor a Menor",
    popular: "Más Popular",
    no_listings: "No se encontraron anuncios",
    views: "vistas",
    contact_seller: "Contactar Vendedor",
    send_message: "Enviar Mensaje",
    propose_trade: "Proponer Intercambio",
    private_seller: "Vendedor Privado",
    business: "Negocio",
    email: "Correo",
    password: "Contraseña",
    name: "Nombre Completo",
    phone: "Teléfono",
    account_type: "Tipo de Cuenta",
    private_account: "Cuenta Privada",
    business_account: "Cuenta de Negocio",
    business_name: "Nombre del Negocio",
    kvk_number: "Número de Registro (KVK)",
    preferred_language: "Idioma Preferido",
    preferred_currency: "Moneda Preferida",
    register: "Registrarse",
    login: "Iniciar Sesión",
    already_have_account: "¿Ya tienes cuenta?",
    dont_have_account: "¿No tienes cuenta?",
    title: "Título",
    description: "Descripción",
    listing_type: "Tipo de Anuncio",
    sell: "Vender",
    rent: "Alquilar",
    trade: "Intercambiar",
    service: "Servicio",
    images: "Imágenes",
    features: "Características",
    add_feature: "Agregar Característica",
    contact_info: "Información de Contacto",
    pricing: "Precios",
    amount: "Monto",
    price_type: "Tipo de Precio",
    no_tax: "Sin Impuesto",
    incl_tax: "Incluyendo OB",
    excl_tax: "Excluyendo OB",
    ob_percentage: "Porcentaje OB",
    hourly_rate: "Tarifa por Hora",
    additional_costs: "Costos Adicionales",
    trade_options: "Opciones de Intercambio",
    trade_value: "Valor de Intercambio",
    trade_preferences: "¿Por qué intercambiarías?",
    address: "Dirección",
    city: "Ciudad",
    area: "Área",
    country: "País",
    use_current_location: "Usar Ubicación Actual",
    dark_mode: "Modo Oscuro",
    light_mode: "Modo Claro",
    yard_sale: "Venta de Garaje",
    porch_sale: "Venta de Porche",
    auction: "Subasta",
    bulk_sale: "Venta al Por Mayor",
    special_listings: "Listados Especiales",
    discover_deals: "Descubre Ofertas Increíbles",
    host_yard_sale: "Organiza una Venta de Garaje",
    start_auction: "Iniciar una Subasta",
    safety_tips: "Consejos de Seguridad",
    meet_public: "Reúnete en un lugar público",
    check_item: "Revisa el artículo antes de pagar",
    no_advance: "No pagues por adelantado",
    report_suspicious: "Reporta actividad sospechosa",
    location_on_request: "Ubicación a solicitud del vendedor",
    view_location: "Ver Ubicación",
    tap_to_view_map: "Toca para ver el mapa",
    support_us: "Apóyanos",
    donation_text: "Ayúdanos a mantener esta plataforma gratuita",
    pool: "Piscina",
    sea_view: "Vista al Mar",
    garden: "Jardín",
    garage: "Garaje",
    carport: "Cochera",
    air_conditioning: "Aire Acondicionado",
    furnished: "Amueblado",
    parking: "Estacionamiento",
    security: "Seguridad",
    balcony: "Balcón",
    property_amenities: "Comodidades",
    // Footer
    footer_tagline: "El mercado de confianza para las islas ABC.",
    footer_explore: "Explorar",
    footer_resources: "Recursos",
    footer_contact: "Contacto",
    footer_events: "Eventos",
    footer_hotspots: "Hotspots",
    footer_about: "Sobre Nosotros",
    footer_install_app: "Instalar App",
    footer_boost_listing: "Promocionar Anuncio",
    footer_currency_converter: "Conversor de Moneda",
    footer_faq: "Preguntas Frecuentes",
    footer_feedback: "Comentarios",
    footer_terms: "Términos",
    footer_privacy: "Privacidad",
    // Footer forms
    advertise_with_us: "Anuncie Con Nosotros",
    have_suggestions: "¿Tienes Sugerencias?",
    your_message: "Tu Mensaje",
    company_name: "Nombre de Empresa",
    submit: "Enviar",
    sending: "Enviando...",
    search_radius: "Radio de Búsqueda",
    use_my_location: "Usar Mi Ubicación",
    within_km: "Dentro de {km} km",
    switch_account: "Cambiar Cuenta",
    link_account: "Vincular Cuenta",
    linked_accounts: "Cuentas Vinculadas",
    // Navigation & Actions
    logout: "Cerrar Sesión",
    favorites: "Favoritos",
    messages: "Mensajes",
    notifications: "Notificaciones",
    settings: "Configuración",
    // Auth extended
    confirm_password: "Confirmar Contraseña",
    full_name: "Nombre Completo",
    create_account: "Crear Cuenta",
    creating_account: "Creando Cuenta...",
    or_continue_with: "O continuar con",
    guest: "Invitado",
    // StartSellingPage
    start_selling: "Empezar a Vender",
    hero_title: "Convierte Tus Artículos en Dinero",
    hero_subtitle: "Únete a miles de vendedores en las islas ABC",
    benefit_1: "Alcanza Compradores Locales",
    benefit_1_desc: "Conecta con compradores en Aruba, Bonaire y Curaçao",
    benefit_2: "Listado Fácil",
    benefit_2_desc: "Crea tu anuncio en minutos con nuestro formulario simple",
    benefit_3: "Transacciones Seguras",
    benefit_3_desc: "Mensajes seguros y perfiles verificados",
    // Analytics
    boost_click: "Clic de Impulso",
    dismiss_click: "Clic de Cerrar",
    popup_view: "Vista de Popup",
    promotion: "Promoción",
    conversation: "Conversación",
    // Business CTA & Campaign
    cta_view_promo: "Ver Promoción",
    cta_view_event: "Descubrir Evento",
    cta_view_sale: "Ver Venta",
    campaign_ends: "Termina el:",
    campaign_active: "Válido hasta:",
    campaign_starts: "Comienza:",
    campaign_running: "Activo ahora",
    cta_url_label: "Enlace Externo (URL)",
    cta_url_placeholder: "https://tutienda.com/promo",
    cta_type_label: "Tipo de Botón",
    cta_type_promotion: "Promoción / Oferta",
    cta_type_event: "Evento / Venta de Fin de Semana",
    cta_type_sale: "Venta",
    campaign_period: "Período de Campaña",
    campaign_start_label: "Fecha de Inicio",
    campaign_end_label: "Fecha de Fin",
    cta_business_only: "Solo disponible para cuentas comerciales verificadas",
    cta_section_title: "Call-to-Action & Campaña",
    cta_section_desc: "Agrega un enlace externo para dirigir tráfico a tu tienda web o página de promoción",
    // Common
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    share: "Compartir",
    report: "Reportar",
    contact: "Contacto",
    categories: "Categorías",
    buy: "Comprar",
    // Profile Page
    active_sessions: "Sesiones Activas",
    add_banner_photo: "Agregar foto de banner",
    all_your_bids: "Todas tus ofertas en subastas",
    all_your_events: "Todos tus eventos y RSVP",
    all_your_listings: "Todos tus anuncios",
    all_your_messages: "Todos tus mensajes y conversaciones",
    crypto: "Cripto",
    dark: "Oscuro",
    light: "Claro",
    system: "Sistema",
    delete_account: "Eliminar Cuenta",
    invalidate_sessions: "Invalidar todas las sesiones activas",
    permanently_delete: "Eliminar permanentemente la cuenta y todos los datos. No se puede deshacer.",
    require_login: "Requerir iniciar sesión de nuevo",
    sign_out_all: "Cerrar sesión en todos los dispositivos si hay acceso no autorizado",
    sign_you_out: "Cerrar sesión en todos los dispositivos",
    theme: "Tema",
    this_will_delete: "Esto eliminará permanentemente:",
    this_will: "Esto:",
    usdt_erc20: "USDT (ERC20)",
    verified: "Verificado",
    whatsapp: "WhatsApp",
    your_profile_info: "Tu perfil e información de cuenta",
    member_since: "Miembro desde",
    // Create Listing
    select_category: "Seleccionar categoría",
    select_subcategory: "Seleccionar subcategoría",
    describe_item: "Describe tu artículo en detalle...",
    item_name: "Nombre del artículo",
    qty: "Cant.",
    buy_all_for: "Comprar todo por...",
    optional: "Opcional",
    describe_trade: "Describe por qué intercambiarías...",
    leave_empty: "Dejar vacío para no tener mínimo",
    step: "Paso",
    next: "Siguiente",
    back: "Atrás",
    publish: "Publicar",
    upload_images: "Subir Imágenes",
    drag_drop: "Arrastra imágenes o haz clic para buscar",
    max_images: "Máximo {count} imágenes",
    required: "Requerido",
    // Auction
    auction_settings: "Configuración de Subasta",
    starting_bid: "Oferta Inicial",
    reserve_price: "Precio de Reserva",
    bid_increment: "Incremento de Oferta",
    end_time: "Hora de Fin",
    auto_extend: "Extensión Automática",
    current_bid: "Oferta Actual",
    place_bid: "Hacer Oferta",
    your_bid: "Tu Oferta",
    bid_placed: "Oferta Realizada",
    outbid: "Superado",
    winning: "Ganando",
    ended: "Finalizado",
    // Messaging
    new_message: "Nuevo Mensaje",
    type_message: "Escribe un mensaje...",
    send: "Enviar",
    online: "En línea",
    offline: "Desconectado",
    last_seen: "Visto por última vez",
    no_messages: "Sin mensajes aún",
    start_conversation: "Iniciar una conversación",
    // Status
    available: "Disponible",
    sold: "Vendido",
    reserved: "Reservado",
    pending: "Pendiente",
    active: "Activo",
    inactive: "Inactivo",
    // Errors
    error_occurred: "Ocurrió un error",
    try_again: "Intentar de nuevo",
    loading: "Cargando...",
    no_results: "No se encontraron resultados",
    // Confirmation
    are_you_sure: "¿Estás seguro?",
    yes: "Sí",
    no: "No",
    confirm: "Confirmar",
    // Time
    today: "Hoy",
    yesterday: "Ayer",
    days_ago: "hace {count} días",
    hours_ago: "hace {count} horas",
    minutes_ago: "hace {count} minutos",
    just_now: "Ahora mismo",
    // Pricing Page
    pricing_hero_title: "Anuncios Gratis,",
    pricing_hero_highlight: "Boost para Más Visibilidad",
    pricing_hero_subtitle: "Publica tus anuncios gratis. ¿Quieres vender más rápido? Impulsa tu anuncio para aparecer en los primeros lugares.",
    pricing_free_title: "Anuncios Gratis",
    pricing_free_subtitle: "Sin costos ocultos, sin suscripciones",
    pricing_free_features_1: "Anuncios ilimitados",
    pricing_free_features_2: "10 fotos por anuncio",
    pricing_free_features_3: "30 días activo",
    pricing_free_features_4: "Renovación automática",
    pricing_free_features_5: "Enviar mensajes",
    pricing_free_features_6: "Estadísticas básicas",
    pricing_free_cta: "Publicar Anuncio Gratis",
    pricing_boost_title: "Impulsa Tu Anuncio",
    pricing_boost_subtitle: "Más visibilidad, vende más rápido",
    pricing_boost_feature_1: "Primero en resultados de búsqueda",
    pricing_boost_feature_2: "Insignia de boost llamativa",
    pricing_boost_feature_3: "Más vistas y respuestas",
    pricing_boost_cta: "Impulsar Ahora",
    pricing_boost_popular: "POPULAR",
    pricing_boost_payment_info: "Pago seguro con",
    pricing_boost_instant: "Activación instantánea después del pago",
    pricing_hours: "horas",
    pricing_days: "días",
    pricing_hour_boost: "horas de boost",
    pricing_day_boost: "días de boost",
    pricing_faq_title: "Preguntas Frecuentes",
    pricing_faq_1_q: "¿Es realmente gratis publicar anuncios?",
    pricing_faq_1_a: "¡Sí! Puedes publicar anuncios ilimitados sin costo. Solo pagas una pequeña tarifa si quieres más visibilidad con un Boost.",
    pricing_faq_2_q: "¿Cuánto tiempo permanece mi anuncio en línea?",
    pricing_faq_2_a: "Tu anuncio permanece activo por 30 días. Después puedes extenderlo fácilmente desde tu panel de control.",
    pricing_faq_3_q: "¿Cómo funciona el Boost?",
    pricing_faq_3_a: "Con un Boost, tu anuncio aparece primero en los resultados de búsqueda y obtiene una insignia llamativa. Esto te da más vistas y te ayuda a vender más rápido.",
    pricing_faq_4_q: "¿Cómo pago por un Boost?",
    pricing_faq_4_a: "Usamos Sentoo para pagos seguros. Tu Boost se activa inmediatamente después del pago.",
    pricing_faq_5_q: "¿Puedo impulsar múltiples anuncios?",
    pricing_faq_5_a: "Sí, puedes impulsar cada anuncio por separado. Así decides qué artículos reciben atención extra.",
    pricing_cta_title: "¿Listo para Vender?",
    pricing_cta_subtitle: "Publica tu primer anuncio ahora. ¡Es gratis y estará en línea en minutos!",
    pricing_cta_button: "Publicar Anuncio Gratis",
    // Boost package names & descriptions
    pricing_boost_24h_name: "Boost 24 Horas",
    pricing_boost_24h_desc: "Pon tu anuncio en la cima por 24 horas",
    pricing_boost_7d_name: "Boost 7 Días",
    pricing_boost_7d_desc: "Pon tu anuncio en la cima por 7 días",
    pricing_boost_30d_name: "Boost 1 Mes",
    pricing_boost_30d_desc: "Pon tu anuncio en la cima por 30 días",
    // Homepage sections
    fresh_arrivals: "Recién Llegados",
    just_listed: "Recién Publicados",
    browse_categories: "Explorar Categorías",
    view_all: "Ver todo",
    upcoming_events: "Próximos Eventos",
    dont_miss_experiences: "No te pierdas estas experiencias",
    browse_listings: "Ver Anuncios",
    create_and_list: "Crear y Publicar",
    create_a_listing: "Crear Anuncio",
    create_and_promote: "Crear y Promocionar",
    browse: "Explorar",
    create_event: "Crear Evento",
    browse_all_events: "Ver Todos los Eventos",
    view_all_listings: "Ver Todos los Anuncios",
    browse_promoted_deals: "Ver {count}+ ofertas promocionadas",
    // Search
    search_marketplace: "Buscar en YourBuySite...",
    search_category: "Buscar en {category}...",
    // Navigation
    create: "Crear",
    subcategory: "Subcategoría",
    all: "Todo",
    // Mobile nav
    home: "Inicio",
    search: "Buscar",
    inbox: "Mensajes",
    profile: "Perfil",
    // Homepage sections - additional
    trending_now: "Tendencias",
    featured_listings: "Anuncios Destacados",
    want_listing_stand_out: "¿Quieres que tu anuncio destaque?",
    promote_your_listing: "Promociona Tu Anuncio",
    host_an_event: "Organiza un Evento",
    share_event_community: "Comparte tu evento con la comunidad isleña",
    check_whats_happening: "Descubre qué está pasando en las islas",
    explore_marketplace: "Explora el Mercado",
    find_what_looking_for: "Encuentra lo que buscas en todas las categorías",
    popular: "Popular",
    services_nav: "Servicios",
    ready_to_start_selling: "¿Listo para Empezar a Vender?",
    join_thousands_sellers: "Únete a miles de vendedores isleños. Publica gratis y llega a compradores en todas las islas.",
    start_selling_free: "Empieza a Vender Gratis",
    advertise_with_us: "Anúnciate Con Nosotros",
    reach_buyers_abc: "Llega a compradores en las islas ABC",
    register_business: "Registrar Negocio",
    // Featured section
    get_featured: "¡Destácate!",
    why_feature_listing: "¿Por qué destacar tu anuncio?",
    more_visibility: "5x más visibilidad",
    priority_search: "Prioridad en resultados de búsqueda",
    homepage_spotlight: "Destacado en la página principal",
    trusted_seller_badge: "Insignia de vendedor confiable",
    promote_listing_reach: "Promociona tu anuncio para llegar a más compradores. ¡Los anuncios destacados obtienen 5x más vistas!",
    find_deals_yard_sales: "Encuentra ofertas en ventas de garaje locales",
  }
};

export default TRANSLATIONS;
